// import { StoreLocator } from '@/sanity.types';

export const DEFAULT_STORE_SELECTOR_VALUE: any = {
  _createdAt: '2025-08-27T08:53:54Z',
  _id: 'storeLocator',
  _rev: 'Ph6oaCobpA5RE5BIFbXCyH',
  _type: 'storeLocator',
  _updatedAt: '2025-09-03T11:25:16Z',
  headline: {
    headingAlignment: 'left',
    shortSummary: 'Find your nearest Porta stockist and start building with confidence.',
    title: 'Bring Porta Home',
  },
  name: 'hrhr',
  storesList: [
    {
      _key: '44898b892945',
      _type: 'singleStore',
      address: '3 Đường Số 12, An Lạc A, Bình Tân, Hồ Chí Minh, Vietnam',
      storeAddress: {
        _type: 'geopoint',
        lat: 10.7454015,
        lng: 106.6169299,
      },
      storeHours: {
        _type: 'storeHours',
        friday: {
          closed: true,
        },
        monday: {
          closeTime: '09:06 PM',
          closed: false,
          openTime: '09:05 AM',
        },
        saturday: {
          closed: true,
        },
        sunday: {
          closed: true,
        },
        thursday: {
          closed: true,
        },
        tuesday: {
          closed: true,
        },
        wednesday: {
          closeTime: '10:00 PM',
          closed: false,
          openTime: '09:00 AM',
        },
      },
      storeName: 'A&V Distributors (Stockist)',
      storeTelephone: '0906548253',
      timezone: 'Asia/Saigon',
    },
    {
      _key: '6ae65262f6b8',
      _type: 'singleStore',
      address: '5Q27Q5MG+V2',
      storeAddress: {
        _type: 'geopoint',
        lat: -29.215370199396418,
        lng: 125.17501720007738,
      },
      storeName: 'A&V Distributors (Stockist) 2',
      storeTelephone: '+123123124',
      timezone: 'Australia/Perth',
    },
    {
      _key: 'ee910b36b702',
      _type: 'singleStore',
      address: '85GVCFXJ+79',
      storeAddress: {
        _type: 'geopoint',
        lat: 40.44812755150513,
        lng: -102.51903595807518,
      },
      storeName: 'AA&V Distributors (Stockist) 3',
      timezone: 'America/Denver',
    },
    {
      _key: '508c1fb9ad93',
      _type: 'singleStore',
      address: 'M767+W7 Vyazhny, Belarus',
      storeAddress: {
        _type: 'geopoint',
        lat: 52.662270169201,
        lng: 29.26322595691352,
      },
      storeName: 'A&V Distributors (Stockist) 4',
      timezone: 'Europe/Minsk',
    },
    {
      _key: 'a6b13a6f442a',
      _type: 'singleStore',
      address: '5Q4MPMFG+MQ',
      storeAddress: {
        _type: 'geopoint',
        lat: -27.275770282836845,
        lng: 133.67689668791934,
      },
      storeName: 'A&V Distributors (Stockist) 5',
      timezone: 'Australia/Adelaide',
    },
  ],
};

const DEFAULT_NAV_ITEM = {
  _type: 'navigationItem',
  icon: null,
  label: 'Products',
  link: {
    _type: 'link',
    isOpenInNewTab: false,
    type: 'external',
    url: '',
  },
  navigationType: 'item',
};

export const DEFAULT_NAV_ARRAY = Array(5).fill(DEFAULT_NAV_ITEM);
